class StickyAtcContainer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const target = document.querySelector('product-info .product-form__submit');
        const triggerSection = this.findCustomerSection();
        const footer = document.querySelector('.shopify-section-group-footer-group, footer, .u-footer_background');
        let hasReachedTrigger = false;
        let isAtFooter = false;
        let footerCheckFrame = null;

        this.watchNewsletterPopup();

        const updateVisibility = () => {
            if (hasReachedTrigger && !isAtFooter) {
                this.classList.remove('hidden');
            } else {
                this.classList.add('hidden');
            }
        };

        const getStickyBoundaryHeight = () => {
            if (this.offsetHeight > 0) return this.offsetHeight;

            return window.matchMedia('(min-width: 768px)').matches ? 174 : 96;
        };

        const checkFooterBoundary = () => {
            footerCheckFrame = null;

            if (!footer) {
                isAtFooter = false;
                updateVisibility();
                return;
            }

            const footerTop = footer.getBoundingClientRect().top;
            const stickyHeight = getStickyBoundaryHeight();
            isAtFooter = footerTop <= window.innerHeight - stickyHeight - 8;
            updateVisibility();
        };

        const requestFooterBoundaryCheck = () => {
            if (footerCheckFrame) return;
            footerCheckFrame = window.requestAnimationFrame(checkFooterBoundary);
        };

        const checkTriggerBoundary = () => {
            if (!triggerSection) return;

            const triggerTop = triggerSection.getBoundingClientRect().top;
            hasReachedTrigger = triggerTop <= window.innerHeight;
            requestFooterBoundaryCheck();
        };

        if (triggerSection) {
            checkTriggerBoundary();
            window.addEventListener('scroll', checkTriggerBoundary, { passive: true });
            window.addEventListener('resize', checkTriggerBoundary);
        } else if (target) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    hasReachedTrigger = !entry.isIntersecting && window.scrollY > target.offsetTop;
                    requestFooterBoundaryCheck();
                });
            });
            observer.observe(target);
        }

        if (!target) {
            hasReachedTrigger = !triggerSection;
            checkFooterBoundary();
            window.addEventListener('scroll', requestFooterBoundaryCheck, { passive: true });
            window.addEventListener('resize', requestFooterBoundaryCheck);
            return;
        }
        checkFooterBoundary();

        if (footer) {
            window.addEventListener('scroll', requestFooterBoundaryCheck, { passive: true });
            window.addEventListener('resize', requestFooterBoundaryCheck);
        }


        document.addEventListener('DOMContentLoaded', () => {
            this.querySelector('.close-icon').addEventListener('click', () => {
                document.querySelector('sticky-atc-container').remove();
            })
            this.querySelector('.product-variant-id').addEventListener('change', (event) => {
                let selectedPrice = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-price');
                this.querySelector('.atc-product-price-element .amount').textContent = selectedPrice;
                if (event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price')) {
                    this.querySelector('.atc-product-price-strikethrough').textContent = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price');
                } else {
                    this.querySelector('.atc-product-price-strikethrough').textContent = '';
                }
                if(this.querySelector('[data-discount-controller-variant]')) {
                    this.querySelector('[data-discount-controller-variant]').setAttribute('data-discount-controller-variant', event.target.value);
                }
            });
            this.querySelector('.product-variant-id').dispatchEvent(new CustomEvent('change'));
        })
    }

    watchNewsletterPopup() {
        if (!window.matchMedia('(max-width: 767px)').matches || !window.MutationObserver) return;

        let updateFrame = null;

        const isVisible = (element) => {
            if (!element || !element.isConnected) return false;

            const style = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();

            return style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                Number(style.opacity || 1) > 0 &&
                rect.width > 0 &&
                rect.height > 0;
        };

        const hasFixedAncestor = (element) => {
            let current = element;

            while (current && current !== document.body) {
                if (window.getComputedStyle(current).position === 'fixed') return true;
                current = current.parentElement;
            }

            return false;
        };

        const popupIsOpen = () => {
            const newsletterElements = document.querySelectorAll([
                '[class*="klaviyo-form" i]',
                '[id*="klaviyo-form" i]',
                'form[action*="klaviyo" i]',
                'iframe[src*="klaviyo" i]'
            ].join(','));

            return Array.from(newsletterElements).some((element) => {
                if (!isVisible(element)) return false;

                const dialog = element.closest('[role="dialog"], [aria-modal="true"]');
                return (dialog && isVisible(dialog)) || hasFixedAncestor(element);
            });
        };

        const update = () => {
            updateFrame = null;
            document.body.classList.toggle('newsletter-popup-open', popupIsOpen());
        };

        const requestUpdate = () => {
            if (updateFrame) return;
            updateFrame = window.requestAnimationFrame(update);
        };

        const observer = new MutationObserver(requestUpdate);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
        });

        window.addEventListener('resize', requestUpdate);
        requestUpdate();
    }

    findCustomerSection() {
        const candidates = document.querySelectorAll('main .shopify-section, main section, main [id]');

        return Array.from(candidates).find((candidate) => {
            if (candidate.contains(this)) return false;

            const text = (candidate.textContent || '').toLowerCase();
            return text.includes('200.000') && text.includes('zufriedene') && text.includes('kunden');
        }) || null;
    }

}
customElements.define('sticky-atc-container', StickyAtcContainer);
